import formatName from 'I18n/utils/formatName';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { UnknownSenderText } from 'conversations-message-history/senders/components/UnknownSenderText';
import { HS_PHONE_NUMBER } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
import { getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import { getSenderDeliveryIdentifierType, getSenderDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
/** @deprecated use "senderName" value directly */
const FullSenderName = ({
  genericSenders,
  isLoading,
  sender,
  senderName: friendlySenderName
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      width: 100
    });
  }
  if (friendlySenderName) return /*#__PURE__*/_jsx(_Fragment, {
    children: friendlySenderName
  });
  const genericSender = genericSenders && genericSenders.size > 0 ? genericSenders.first() : undefined;
  const deliveryIdentifierType = genericSender ? getSenderDeliveryIdentifierType(genericSender) : undefined;
  const deliveryIdentifierValue = genericSender ? getSenderDeliveryIdentifierValue(genericSender) : undefined;
  const legacySenderName = sender && formatName({
    firstName: getFirstName(sender),
    lastName: getLastName(sender),
    email: getEmail(sender)
  });
  if (legacySenderName) return /*#__PURE__*/_jsx(_Fragment, {
    children: legacySenderName
  });
  if (deliveryIdentifierType === HS_PHONE_NUMBER && deliveryIdentifierValue) {
    return /*#__PURE__*/_jsx(FormattedPhoneNumber, {
      value: deliveryIdentifierValue
    });
  }
  return /*#__PURE__*/_jsx(UnknownSenderText, {
    sender: sender
  });
};
FullSenderName.displayName = 'SenderName';
export default FullSenderName;